class ImageResource {
  public static preloadImages = async (imageUrls: string[]): Promise<any[]> =>
    Promise.all(
      imageUrls.map((url) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = resolve;
          img.onerror = reject;
          img.src = url;
        });
      }),
    );

  public static preloadImage = async (url: string): Promise<any> =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = resolve;
      img.onerror = reject;
      img.src = url;
    });
}

export default ImageResource;
